import { createAction, props } from "@ngrx/store";
import { RentVsBuyDbType } from "@home-shark/types";
import {
    filtersUpdated,
    updateFilters,
} from "../../search/actions/filters.actions";

export const updateRentVsBuy = createAction(
    "[Rent Vs Buy] Update Input",
    props<{ state: RentVsBuyDbType }>()
);

export type RentVsBuyActionsTypes = typeof updateFilters | typeof filtersUpdated;
